import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Route, Switch, Redirect, } from "react-router-dom";
import store from "./store";
import { loadParamsFromStorage } from "./services/params";
import { loadSiteFromStorage } from "./services/site";
import { GlobalDebug } from "./utils/remove-consoles";
import axios from "axios";
import AuthProvider from "./utils/authProvider";
import PrivateRoute from "./utils/protectedRoute";
import oauth, { loadUserFromStorage } from "./services/oauth";
import AuthLayout from "./layouts/Auth.js";
import AdminLayout from "./layouts/Admin.js";

import ListView from "views/ListView";
import CatalogView from "views/CatalogView";
import SearchView from "views/SearchView";
import PDFView from "views/PDFView";
import InitView from "views/InitView";

function App() {
    const site = useSelector(state => state.site);

    const favicon = (url) => {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'shortcut icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = url + '/catalogo/res/favicon';
    }

    useEffect(() => {
        console.log('SITE PARAM BEGIN');
        if (site.site) {
            console.log(site.site);
            loadParamsFromStorage(store, site.site.apiServer, 'brand');
            favicon(site.site.apiServer);
        } else if (site.siteError) {
            console.log("Error load�ng site params");
        }
        return () => { console.log('SITE PARAM END'); }
    }, [site]);

    useEffect(() => {
        (process.env.NODE_ENV === "production" || process.env.REACT_APP_ENV === "STAGING") && GlobalDebug(false);
        console.log('APP BEGIN');
        const source = axios.CancelToken.source();
        if (!(window.location.pathname.startsWith('/vl') || window.location.pathname.startsWith('/vc') || window.location.pathname.startsWith('/pdf') || window.location.pathname.startsWith('/pdfweb'))) {
            loadUserFromStorage(store);
        }
        loadSiteFromStorage(store);
        console.log(process.env.REACT_APP_BUILD);
        return () => { if (source) source.cancel('change view'); console.log('APP END'); }
    }, []);

    return (
        <>
            {site.site && (
                <AuthProvider userManager={oauth} store={store}>
                    <BrowserRouter>
                        <Switch>
                            <PrivateRoute path="/admin" render={(props) => <AdminLayout {...props} />} />
                            <PrivateRoute path="/vs" render={(props) => <SearchView {...props} />} />
                            <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
                            <Route path="/vl" render={(props) => <ListView {...props} />} />
                            <Route path="/vc" render={(props) => <CatalogView {...props} />} />
                            <Route path="/pdf" render={(props) => <PDFView {...props} />} />
                            <Route path="/pdfweb" render={(props) => <PDFView {...props} />} />
                            <Redirect from="/" to="/admin/dashboard" />
                        </Switch>
                    </BrowserRouter>
                </AuthProvider>
            )}
            {!site.site && (<InitView />)}
        </>
    );
}
export default App;